<template>
  <v-alert :type="type" border="top" dense v-bind="$attrs" v-on="$listeners" v-if="show">
    {{ message }}
  </v-alert>
</template>

<script>
export default {
  name: "AlertDisplay",
  props: {
    durationOption: {
      type: String,
      default: "short",
      validator: function(value) {
        return ["short", "long", "never"].indexOf(value) !== -1;
      }
    }
  },
  data() {
    return {
      show: false,
      message: "",
      type: "",
      timeoutId: null
    };
  },
  computed: {
    duration() {
      switch (this.durationOption) {
        case "short":
          return 3000; // 3 seconds
        case "long":
          return 60000; // 1 minute
        case "never":
          return -1; // Never closes
        default:
          return 10000; // Fallback to 3 seconds
      }
    }
  },
  methods: {
    info(message) {
      this.showAlert("info", message);
    },

    success(message) {
      this.showAlert("success", message);
    },

    warning(message) {
      this.showAlert("warning", message);
    },

    error(message) {
      this.showAlert("error", message);
    },

    showAlert(type, message) {
      this.show = true;
      this.message = message;
      this.type = type;

      if (this.timeoutId) clearTimeout(this.timeoutId);

      if (this.duration !== -1) {
        this.timeoutId = setTimeout(() => {
          this.resetAlert();
          this.timeoutId = null;
        }, this.duration);
      }
    },

    resetAlert() {
      if (this.timeoutId) clearTimeout(this.timeoutId);

      this.timeoutId = null;
      this.show = false;
      this.message = "";
      this.type = "";
    }
  }
};
</script>
